<template lang="html">
  <header class="header" :min="min">

    <div class="top row-between">

      <div class="right row-start">
        <router-link to="/">
          <img width="150" class="logo" src="/static/img/logo.svg" alt="LOGO Dotia">
        </router-link>
      </div>

      <div class="left row-end ais">
        <div class="block-btns">
          <span @click="toggleLinks">Acceder</span>
          <a v-if="showLinks" href="https://portal-demoempleo.dotia.online/login/empresas" class="btn -small">Acceso
            empresas</a>
          <a v-if="showLinks" href="https://portal-demoempleo.dotia.online/login/alumnos" class="btn -small">Acceso
            titulados</a>

        </div>

        <!-- <a :href="$t('portaltutores')" class="btn -small -tutores">Acceso tutores académicos</a> -->

        <button class="show-menu column-start" @click="showmenu = true">
          <span></span>
          <span></span>
          <span></span>
        </button>

      </div>

    </div>

    <div class="bottom row-center" :show="showmenu">

      <div class="left row-center">
        <router-link to="/">
          <img src="/static/img/logo.svg" alt="Logo Dotia">
        </router-link>
      </div>
      <div class="right column-center">
        <a @click="showmenu = false" class="close-menu">✕</a>
        <div class="contenedor-enlaces column-start">
          <router-link to="/" class="logo">
            <img src="/static/img/logo-color.svg" alt="logo">
          </router-link>
          <!--           <a @click="childs.servicios = !childs.servicios" class="parent row-start" :show="childs.servicios" :active="inServicios">Servicios</a>
          <div class="child column-start" v-show="childs.servicios">
            <router-link :to="$t('enlaces.titulados')">Titulados</router-link>
            <router-link :to="$t('enlaces.empresas')">Empresas</router-link>
            <router-link :to="$t('enlaces.tutores')">Tutores</router-link>
          </div>
          <router-link :to="$t('enlaces.programasyofertas')">Programas y ofertas</router-link>
          <router-link :to="$t('enlaces.contacto')">Contacto</router-link> -->
          <!-- <router-link :to="$t('enlaces.faqs')">FAQs</router-link> -->

          <router-link :to="$t('enlaces.titulados')">Candidatos</router-link>
          <router-link :to="$t('enlaces.empresas')">Empresas</router-link>
          <router-link :to="$t('enlaces.contacto')">Contacto</router-link>

          <a @click="childs.acceso = !childs.acceso" class="parent row-start hidden-destokp"
            :show="childs.acceso">Acceder</a>
          <div class="child column-start" v-show="childs.acceso">
            <a href="https://portal-demoempleo.dotia.online/login/empresas">Acceso empresas</a>
            <a href="https://portal-demoempleo.dotia.online/login/alumnos">Acceso titulados</a>
            <a :href="$t('portaltutores')">Acceso tutores académicos</a>
          </div>
        </div>
      </div>

    </div>

  </header>
</template>

<script lang="js">
export default {
  name: 'app-header',
  mounted() {
    this.min = ($(window).scrollTop() >= 180);
    $(window).scroll(e => {
      this.min = ($(window).scrollTop() >= 180);
    });
  },
  data() {
    return {
      showmenu: false,
      showLinks: false,
      min: false,
      childs: {
        servicios: false,
        acceso: false,
      }
    }
  },
  computed: {
    inServicios() {
      let names = ['tutores', 'titulados', 'empresas'];
      return (names.some(n => n == this.$route.name));
    }
  },
  methods: {
    toggleLinks: function () {
      this.showLinks = !this.showLinks;
    },
  },
  watch: {
    '$route'() {
      this.showmenu = false;
      this.childs.servicios = false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/parts/header.vue